import { createRoot } from 'react-dom/client';
import React from 'react';

import '../index';
import '../../style/main.scss';

export function CreateRoot(container, component) {
  const rootContainer = document.getElementById(container);
  if (rootContainer) {
    const root = createRoot(rootContainer);
    root.render(component);
  }
}
